<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">案件更新</h2>

      <p class="bold_label">タイトル</p>
      <input type="text" class="text_form" v-model="renewWork.title"/>

      <p class="bold_label">詳細（2000文字以内）</p>
      <textarea type="text" class="textarea_form" v-model="renewWork.description"/>

      <p class="bold_label">報酬（円）</p>
      <input type="number" class="text_form" v-model="renewWork.rewards"/>

      <p class="bold_label">見積時間</p>
      <TimeFormBox v-model="workTime" :default-value="renewWork.estimationOfWorkTime" :max="480"/>

      <p class="bold_label">締め切り</p>
      <DatetimeFormBox
        v-model="renewWork.deadline"
        :default-value="renewWork.deadline"
        :is-visible-year="true"
        :is-visible-month="true"
        :is-visible-date="true"
        :is-visible-hour="true"
        :is-visible-minute="true"
      />

      <p class="bold_label">オペレーターが作業するソフトウェアとバージョン</p>
      <SoftwareSelectBox :softwares="renewWork.softwares" :reload-key="true" :is-visible-children="true"/>

      <p class="bold_label">スキル</p>
      <ParentChildChecksBox :prop-parents="renewWork.requiredSkills" :reload-key="true" :is-visible-children="false"/>

      <p class="bold_label">オペレーターの評価（高いほどマッチングしにくくなります）</p>
      <select class="select_form" v-model="renewWork.requiredScores">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="3">3</option>
        <option :value="4">4</option>
      </select>

      <p class="bold_label">CADデータ、提示資料</p>
      <p class="strong_label">※アップロードしてから30日後に自動的に削除されるので、ご注意ください。</p>
      <FileUploaderBox
        :document-urls="renewWork.documentUrls"
        @deleteDocumentUrl="removeDocumentUrls"/>

      <button class="active-rectangle_button" @click="onClickUpdate()">案件更新</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";
  import TimeFormBox from "@/components/molecules/box/form/TimeFormBox";
  import DatetimeFormBox from "@/components/molecules/box/form/DatetimeFormBox";

  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import sub_collection from "@/assets/js/functions/firebase/firestore/sub_collection";
  import ParentChildChecksBox from "@/components/molecules/box/form/ParentChildChecksBox";
  import SOFTWARES from "@/assets/js/constants/softwares";
  import SKILLS from "@/assets/js/constants/skills";
  import STATUSES from "@/assets/js/constants/statuses";
  import FileUploaderBox from "@/components/molecules/box/form/FileUploaderBox";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import SoftwareSelectBox from "@/components/molecules/box/form/SoftwaresSelectBox";

  export default {
    name: "UpdatingWork",

    components: {SoftwareSelectBox, FileUploaderBox, ParentChildChecksBox, TimeFormBox, DatetimeFormBox},

    mixins: [collection, sub_collection],

    data() {
      return {
        workId: '',
        workTime: {
          hour: 0,
          minute: 0,
        },

        renewWork: {
          title: '',
          description: '',
          estimationOfWorkTime: 0,
          rewards: 0,
          deadline: {},
          softwares: {},
          requiredSkills: {},
          requiredScores: 0,
          documentUrls: [],
          bills: null,
        },
      }
    },

    beforeCreate() {
      Object.assign(this, {STATUSES});
      Object.assign(this, {COLLECTION_NAMES});

      Object.assign(this, {SOFTWARES});
      for (let [key] of Object.entries(SOFTWARES)) {
        SOFTWARES[key]['isSelected'] = false;

        for (let [child_key] of Object.entries(SOFTWARES[key].children)) {
          SOFTWARES[key].children[child_key]['isSelected'] = false;
        }
      }

      Object.assign(this, {SKILLS});
      for (let [key] of Object.entries(SKILLS)) {
        SKILLS[key]['isSelected'] = false;

        for (let [child_key] of Object.entries(SKILLS[key].children)) {
          SKILLS[key].children[child_key]['isSelected'] = false;
        }
      }
    },

    created() {
      this.renewWork.softwares = SOFTWARES;
      this.renewWork.requiredSkills = SKILLS;
    },

    async mounted() {
      this.workId = location.pathname.replace('/mypage/client/work/update/', '');
      this.workId = this.workId.replace(/\/*$/, '');

      let tempWork = {};
      await this.getDoc(COLLECTION_NAMES.WORKS, this.workId).then(async readWork => {
        if (this.isEditable(readWork)) {
          tempWork = readWork;
        } else {
          this.showErrorMessage('今は案件を編集できません。');
          this.$router.push({name: 'WorkDetail', params: {workId: this.workId}});
        }
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      this.$nextTick(() => {
        if (tempWork.id) {
          Object.assign(this.renewWork.softwares, tempWork['softwares']);
          Object.assign(this.renewWork.requiredSkills, tempWork['requiredSkills']);
          this.renewWork = tempWork;
        }
        this.reloadKey = true;
      });
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    methods: {
      isEditable(work) {
        return (
          STATUSES.SEARCHING.name === work.status
          || STATUSES.WAITING.name === work.status
          || STATUSES.MEETING.name === work.status
          || STATUSES.WORKING.name === work.status
        )
      },

      onClickUpdate() {
        this.renewWork['estimationOfWorkTime'] = this.workTime.hour * 60 + this.workTime.minute;
        this.renewWork['rewards'] = Number(this.renewWork.rewards);

        STATUSES.SEARCHING.name === this.renewWork.status
          ? this.updateWork() : this.requestUpdatingWork()
      },

      isValidWork() {
        const now = moment();
        if (moment(this.renewWork.deadline).diff(now, 'minutes') <= 0) {
          this.showErrorMessage('締め切りは未来の日付を選択してください');
          return false;
        }
        return true;
      },

      async updateWork() {
        if (!this.isValidWork()) return;

        const requestParams = {
          title: this.renewWork.title,
          description: this.renewWork.description,
          estimationOfWorkTime: this.workTime.hour * 60 + this.workTime.minute,
          rewards: Number(this.renewWork.rewards),
          deadline: this.renewWork.deadline,
          softwares: this.renewWork.softwares,
          requiredSkills: this.renewWork.requiredSkills,
          requiredScores: this.renewWork.requiredScores,
          documentUrls: this.renewWork.documentUrls,
        };

        await this.updateDoc(
          COLLECTION_NAMES.WORKS,
          this.workId,
          requestParams
        ).then(() => {
          this.showSuccessMessage('案件を更新しました。');
          this.$router.push({name: 'WorkDetail', params: {workId: this.workId}});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      async requestUpdatingWork() {
        const requestParams = {
          title: this.renewWork.title,
          description: this.renewWork.description,
          estimationOfWorkTime: this.workTime.hour * 60 + this.workTime.minute,
          rewards: Number(this.renewWork.rewards),
          deadline: this.renewWork.deadline,
          softwares: this.renewWork.softwares,
          requiredSkills: this.renewWork.requiredSkills,
        };

        const subCollectionDocRef = this.subCollectionDocRef(
          COLLECTION_NAMES.WORKS,
          this.workId,
          COLLECTION_NAMES.TEMPS
        );

        await this.createSubCollectionDocument(
          subCollectionDocRef,
          null,
          requestParams,
        ).then(() => {
          this.showSuccessMessage('案件の更新依頼を行いました。');
          this.$router.push({name: 'WorkDetail', params: {workId: this.workId}});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      removeDocumentUrls(index) {
        this.renewWork.documentUrls = this.renewWork.documentUrls.filter((documentUrl, i) => {
          return index !== i;
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $client_primary;

    > .contents {
      @include form-contents();
    }
  }
</style>